export default __webpack_public_path__ + "static/media/7D.bc93fd45.svg";